import AuditLogPage from "auditlog/AuditLogPage";
import AuditLogConfigurationPage from "auditlog/AuditLogConfigurationPage";
import AuditLogRoutes from "./Routes";
export const PAGE_NAV_TITLE = "Audit Log";
const pluginExports = {
  routes: [
    { path: AuditLogRoutes.unqualified.LIST, component: AuditLogPage },
    { path: AuditLogRoutes.unqualified.CONFIGURATION, component: AuditLogConfigurationPage }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Overview", path: AuditLogRoutes.LIST, exactPathMatch: true },
        {
          description: "Configuration",
          path: AuditLogRoutes.CONFIGURATION,
          permissions: "eventdefinitions:read"
        }
      ]
    }
  ]
};
export default pluginExports;
